import { render } from "./adminNavigation.vue?vue&type=template&id=479f8718"
import script from "./adminNavigation.vue?vue&type=script&lang=js"
export * from "./adminNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__